export const getters = {
  getLogs: state => state.logs,
  getLog: state => state.log,
  getLogFiltros: state => state.logFiltros
};

export default {};
